// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__uWhcl","itemTitle":"ClientEmergencyInfo_itemTitle__1SwWl","itemText":"ClientEmergencyInfo_itemText__3nMmP"};